import {UserModel} from './User';

export interface SetupIntentResponse {
    setupIntent: {
        client_secret: string;
    },
    user: UserModel
}

export enum Tiers {
    Free ='free',
    Premium = 'premium',
    PremiumPlus = 'premium_plus'
}
export enum ProductNames {
    Basic = "Basic",
    Premium = "Premium",
    PremiumPlus = "Premium+"
}
export interface Products {
    id: number;
    name: string;
}
export interface Plans {
    id: number;
    name: string;
    stripePlanId: string;
    recurringPrice: number;
    product: Products;
    isTrial: boolean;
}
export interface CouponResponse {
    amount_off: number | null;
    created: number;
    currency: string | null;
    duration: string;
    duration_in_months: number | null;
    id: string;
    livemode: boolean;
    max_redemptions: number | null;
    metadata: Record<string, any>;
    name: string;
    object: string;
    percent_off: number | null;
    redeem_by: number | null;
    times_redeemed: number;
    valid: boolean;
}
export interface UpgradePayload {
    user: UserModel;
    planId: number;
    productId: number;
    partnerName: string;
    paymentMethod: string;
    location: string;
    updateBilling: boolean;
    coupon?: string;
    origin: string;
    trialCode?: string;
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
    trafficSource?: string;
    lead_origin?: string;
    upgrade_source?: string;
    upgrade_campaign?: string;
    upgrade_cohort?: string;
    upgrade_origin?: string;
    upgrade_send_id?: string;
    partnerReferenceId?: string;
}
export interface ApplyCouponResponse {
    status: string;
    message: string;
}

export interface CouponInfo {
    code: string;
    discount: string;
    meta?: CouponMeta;
}

export interface CouponMeta {
    coupon: string;
    percent_off?: number;
    amount_off?: number;
    valid: boolean;
}

export enum MembershipBucket {
    Free = 'free',
    Premium = 'premium',
    PremiumPlus = 'premium_plus'
}

export const bucketById = new Map<number, MembershipBucket>([
    [1, MembershipBucket.Free],
    [17, MembershipBucket.Premium],
    [18, MembershipBucket.Premium],
    [19, MembershipBucket.PremiumPlus],
    [20, MembershipBucket.PremiumPlus],
]);

export function getBucketForId(id: number): MembershipBucket {
    return bucketById.get(id) ?? MembershipBucket.Free;
}



export interface ApplyCouponResponse {
    status: string;
    message: string;
}

export interface TrackingParams {
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    trafficSource: string;
    trialCode: string;
    rfsn: string;
    location: string;
}
export interface CouponInfo {
    code: string;
    discount: string;
    meta?: CouponMeta;
}

export interface CouponMeta {
    coupon: string;
    percent_off?: number;
    amount_off?: number;
    valid: boolean;
}

export interface CardInfo {
    brand: string;
    expMonth: number;
    expYear: number;
    lastFour: number;
}
export interface MembershipInfo {
    amountDue: number;
    cancelAt: number;
    renew: string;
    paymentMethod: CardInfo;
    paused: string | null;
    trialActive: boolean;
    status: string;
}

